import type { Embed } from 'types/capi/content';

import EmbedComponent from '~/components/Content/Embed';

type Props = {
  embed: Embed;
  modulePosition?: number;
};

export default function EmbeddedEmbedBlock({ embed, modulePosition }: Props) {
  return (
    <div className="flex w-full flex-col gap-6">
      <EmbedComponent
        embed={embed}
        modulePosition={modulePosition}
        placement="embed_module"
      />
    </div>
  );
}
